import {drawFigure, colors, decimalPlaces} from "../utils";
import moment from 'moment';
import * as _ from 'lodash';


class CursorValue extends PIXI.Container{
  constructor(App){
    super();
    this.App = App;
    this.graphics = new PIXI.Graphics();
    this.text = new PIXI.Text(gettext('value'));
    this.text.style = {fontSize: '10px', fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fill: colors.marksTextColor};
    this.text.position.set(13, (this.height + this.text.height) / 2);

    this.addChild(this.graphics, this.text);
  }

  render(fillColor){
    drawFigure(
      this.graphics, [[10, 0], [this.App.rightMargin, 0], [this.App.rightMargin, 24], [10, 24], [10, 24], [0, 12], [10, 0]],
      [fillColor, 1], true
    );
  }
}


class CursorTime extends PIXI.Container{
  constructor(){
    super();
    this.graphics = new PIXI.Graphics();
    this.text = new PIXI.Text(gettext('time'));
    this.text.style = {fontSize: '12px', fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fill: colors.marksTextColor};
    this.addChild(this.graphics, this.text);
  }

  render(fillColor){
    let center = this.text.width / 2 + 10;
    this.graphics.clear();
    drawFigure(this.graphics, [[0, 0], [center - 5, 0], [center, -5], [center + 5, 0], [center * 2, 0], [center * 2, 20], [0, 20], [0, 0]],
      [fillColor, 1], true);
  }
}


export class MousePosition extends PIXI.Container{
  constructor(App){
    super();
    this.App = App;

    this.zIndex = 4;

    this.graphics = new PIXI.Graphics();
    this.cursorTime = new CursorTime();
    this.cursorValue = new CursorValue(App);

    this.cursorTime.position.y = App.renderer.height/App.devicePixelRatio * 0.975;
    this.cursorValue.position.x = App.renderer.width/App.devicePixelRatio - App.rightMargin + 10;

    this.cursorTime.render(colors.cursorMarks);
    this.cursorValue.render(colors.cursorMarks);

    this.interactive = true;
    this.on('mousemove', this.mouseMoveHandler.bind(this));

    this.addChild(this.graphics, this.cursorTime, this.cursorValue);
  }


  mouseMoveHandler(event){
    let x = event.data.global.x, y = event.data.global.y;

    if (_.inRange(y, 0, this.App.renderer.height/this.App.devicePixelRatio * 0.95) && _.inRange(x, 0, this.App.renderer.width/this.App.devicePixelRatio))
      this.App.lastMousePosition = {x: x, y: y};
  }


  render(){
    let App = this.App;

    if (App.displayedPoints.length > 0) {
      let p1, p2;

      for (let i = 0; i < App.displayedPoints.length; i++) {
        if (App.displayedPoints[i].x > App.lastMousePosition.x) {
          p1 = App.displayedPoints[i - 1];
          p2 = App.displayedPoints[i];
          break;
        }
      }
      let x, y, color, value, timestamp;

      // sticks mouse position to open order mark
      if (App.stickToOrder) {
        x = App.stickToOrder.x;
        y = App.stickToOrder.y;
        color = App.stickToOrder.color;
        value = App.stickToOrder.value;
        timestamp = App.stickToOrder.moment.format('HH:mm.ss');
      }
      else {
        y = p1 && p2 ? p1.y + (App.lastMousePosition.x - p1.x) * (p2.y - p1.y) / (p2.x - p1.x) + App.chartPosition.top : App.lastMousePosition.y;
        x = App.lastMousePosition.x;
        color = colors.cursorLines;
        value = App.getValue(y).toFixed(decimalPlaces(App.quotes.currentQuote.bid) + 1);
        timestamp = moment(App.getTimestamp(x)).format('YYYY.MM.DD HH:mm.ss');
      }

      this.graphics.clear().lineStyle(1, color, 0.2).moveTo(0, y).lineTo(this.cursorValue.position.x, y);
      this.graphics.moveTo(x, 0).lineTo(x, this.cursorTime.position.y - 5);

      if (App.stickToOrder){
        this.graphics.lineWidth = 0;
        this.graphics.beginFill(colors.chart, 1).drawCircle(App.stickToOrder.openX, App.stickToOrder.openY, 4).endFill();
        this.graphics.lineWidth = 1;
      }

      this.cursorTime.position.x = x - this.cursorTime.width / 2;
      this.cursorTime.text.text = timestamp;
      this.cursorTime.text.position.x = (this.cursorTime.width - this.cursorTime.text.width) / 2;

      this.cursorValue.position.y = y - this.cursorValue.height / 2;
      this.cursorValue.text.text = value;

      this.cursorTime.render(colors.cursorMarks);
      this.cursorValue.render(colors.cursorMarks);
    }
  }
}